export default {
  getSchools: (state) => state.schools,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};
